import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [customer, setCustomer] = useState('');

  const addItem = (product, qty = 1) => {
    setItems((c) => {
      const cap = product.available ?? product.stock ?? qty;
      const found = c.find((i) => i.id === product.id);
      if (found) return c.map((i) => i.id === product.id ? { ...i, qty: Math.min(i.qty + qty, cap) } : i);
      return [...c, { ...product, qty: Math.min(qty, cap) }];
    });
  };

  const changeQty = (id, delta) =>
    setItems((c) => c.map((i) => {
      if (i.id !== id) return i;
      const cap = i.available ?? i.stock ?? 9999;
      return { ...i, qty: Math.max(1, Math.min(i.qty + delta, cap)) };
    }));

  const removeItem = (id) => setItems((c) => c.filter((i) => i.id !== id));

  const clear = () => { setItems([]); setCustomer(''); };

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const totalItems = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, customer, setCustomer, addItem, changeQty, removeItem, clear, subtotal, totalItems }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
};
